export class WidgetSettings {
  public widgetId: string;
  public colour: string;
  public drillDownRoute: string;
  public drillDownFilters: Map<string, any[]>;

  constructor(widgetId: string, colour: string, drillDownRoute: string, drillDownFilters: Map<string, any[]>) {
    this.widgetId = widgetId;
    this.colour = colour;
    this.drillDownRoute = drillDownRoute;
    this.drillDownFilters = drillDownFilters;
  }
}
